import {parseAxiosPromise} from '@/axiosInstance.ts'
import {useInfiniteQuery} from '@tanstack/react-query'
import {infiniteQueryFetchNextPage, QUERY_KEYS} from '@/queryClient.ts'
import {httpGetPaymentsDates} from '@features/payments/http/payments.http.ts'
import {captureException} from '@sentry/react'
import {FreelancerPaymentDate, PaymentsSearchParams} from '@features/payments/types.ts'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams.ts'
import {format} from 'date-fns'

export const useFreelancerPaymentsDates = () => {
    const {searchParams} = useParsedSearchParams(PaymentsSearchParams)
    const from = format(searchParams.from, 'yyyy-MM-dd')
    const to = format(searchParams.to, 'yyyy-MM-dd')

    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.FREELANCER_PAYMENTS_DATES, from, to],
        queryFn: ({pageParam}) =>
            parseAxiosPromise({
                axiosPromise: httpGetPaymentsDates({
                    params: {
                        limit: 50,
                        page: pageParam ?? 1,
                        from,
                        to,
                        response_type: 'regular'
                    }
                }),
                onZodError: captureException,
                responseShape: FreelancerPaymentDate
            }),
        initialPageParam: 1,
        getNextPageParam: lastPage => (lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : null)
    })

    return {
        ...query,
        remappedData: query.data?.pages[0]?.data ? query.data.pages.flatMap(page => page.data) : [],
        totalPaidOut: query.data?.pages?.at(-1)?.paid_out,
        fetchNextPage: () => infiniteQueryFetchNextPage(query)
    }
}
